import Route from '@ember/routing/route';
import type TeamModel from 'scaleflow/models/team';
import type Controller from '@ember/controller';
export default class OperationsTeamsTeamInitiativesRoute extends Route {
  model() {
    return this.modelFor('operations.teams.team');
  }

  defaultStatus = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
    'PARKED',
    'COMPLETED',
  ];

  setupController(controller: Controller, model: TeamModel) {
    super.setupController(controller, model);
    if (!controller.get('sort')) {
      controller.set('sort', 'status');
    }

    if ((controller.get('statuses') as string[]).length === 0) {
      controller.set('statuses', this.defaultStatus);
    }

    if (!controller.get('grouping')) {
      controller.set('grouping', 'statuses');
    }

    if ((controller.get('columns') as string[]).length === 0) {
      const columns = (
        controller.get('columnOptions') as { show?: boolean; label: string }[]
      ).reduce((acc: string[], item: { label: string; show?: boolean }) => {
        if (item.show === undefined) acc.push(item.label);
        else if (item.show === true) acc.push(item.label);
        return acc;
      }, [] as string[]);
      controller.set('columns', columns);
    }
  }
}
